import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import landingPageConst from '@/constants';
    import useQrStore from '@/store/qr';
    import usePaymentSessionStore from '@/store/paymentSession';
    import Machine from '@/components/Scan2Pay/Machine.vue';
    import Ticket from '@/components/Scan2Pay/Ticket.vue';
    import PaymentMethods from '@/components/common/PaymentMethods/PaymentMethods.vue';
    import { computed } from 'vue';
    import { useRouter } from 'vue-router';
    import ApiClient from '@/utils/apiClient';
    import {
        PaymentProcessingOptions,
        PaymentMethodProviders,
        PaymentMethodTypes,
        BasePayConfiguration,
    } from '@/typings/paymentMethods';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentDetailsView',
  setup(__props) {

    const router = useRouter();
    const qrStore = useQrStore();
    const paymentSessionStore = usePaymentSessionStore();

    var transactionInfo = {
        countryCode: qrStore.countryCode,
        currencyCode: qrStore.currencyCode,
        totalPrice: qrStore.totalPrice,
    };
    var machineName = qrStore.machine.machineName;
    const generateOnClickPaymentOptions = (
        paymentMethodName: PaymentMethodProviders,
        errorNumber: number,
        configuration: any
    ): PaymentProcessingOptions => {
        return {
            gateway: paymentMethodName,
            onLoaded: () => true,
            onSuccess: async (token: string) => {
                var json = {
                    QR: qrStore.token,
                    Payload: token,
                };
                try {
                    var response = await ApiClient.Scan2Pay.apm(json, paymentMethodName);
                    if (response.data.isSuccess) {
                        setTimeout(() => {
                            const paymentSession = {
                                mode: 'Stop',
                                time: 0,
                            };
                            paymentSessionStore.setPaymentSession(paymentSession);
                            window.sessionStorage.setItem('localTimeToExitStr', response.data.localTimeToExitStr);

                            router.push({
                                name: 'Receipt',
                                params: {
                                    transaction: qrStore.token,
                                },
                            });
                        }, 3000);
                        return true;
                    }

                    processPaymentError('Payment was not approved');
                } catch (error) {
                    processPaymentError(error);
                }
                return false;
            },
            onFailure: (err: any) => {
                errorHandler({
                    response: {
                        data: { details: errorNumber },
                    },
                    obj: err,
                });
            },
            configuration,
        };
    };

    const paymentMethods: {
        [key in PaymentMethodTypes]: (
            paymentMethodName: PaymentMethodProviders,
            errorNumber: number,
            configuration: BasePayConfiguration
        ) => PaymentProcessingOptions;
    } = {
        [PaymentMethodTypes.APPLE_PAYMENT_METHOD]: generateOnClickPaymentOptions,
        [PaymentMethodTypes.GOOGLE_PAYMENT_METHOD]: generateOnClickPaymentOptions,
        [PaymentMethodTypes.CREDIT_CARD_PAYMENT_METHOD]: () => {
            return {
                onLoaded: () => {
                    router.push({ name: 'CreditCardPayment' } /*'/static/creditCardPayment'*/);
                    return true;
                },
                configuration: {},
            };
        },
    };
    function instanceOfPayConfig(obj: any): obj is BasePayConfiguration {
        return 'providerName' in obj;
    }
    const paymentMethodOptions = computed(() => {
        const pms: { [key in PaymentMethodTypes]?: PaymentProcessingOptions } = {};
        if (!qrStore.paymentMethodInformation) return null;

        const entries = Object.entries(qrStore.paymentMethodInformation);
        entries.forEach(([key, value]) => {
            const pm = key as PaymentMethodTypes;
            if (value && Object.keys(value).length > 0) {
                if (pm !== null && instanceOfPayConfig(value)) {
                    pms[pm] = paymentMethods[pm](
                        value.providerName,
                        landingPageConst.errors.gPayGenError,
                        value
                    );
                } else {
                    console.log('Payment provider not known: ' + key);
                }
            }
        });
        return pms;
    });

    //methods
    function errorHandler(err: any) {
        console.log(err);
        console.log('errorHandler:' + JSON.stringify(err));
        // setClientError(err);
    }

    function processPaymentError(err: any) {
        const paymentSession = {
            mode: 'Stop',
            time: 0,
        };
        paymentSessionStore.setPaymentSession(paymentSession);
        //console.log('errorHandler:' + JSON.stringify(err));
        router.push({
            name: 'error',
            params: {
                type: 'payment',
            },
        });
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Machine),
    _createVNode(Ticket),
    (_unref(paymentMethodOptions))
      ? (_openBlock(), _createBlock(PaymentMethods, {
          key: 0,
          "payment-methods": _unref(paymentMethodOptions),
          "transaction-info": _unref(transactionInfo),
          "machine-Name": _unref(machineName)
        }, null, 8, ["payment-methods", "transaction-info", "machine-Name"]))
      : _createCommentVNode("", true)
  ]))
}
}

})